import { useCallback, useEffect, useState } from "react";
import { Col, FormControl, InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";
import { CardButton, MultiSelectFilter } from "./styles";
import { MultiSelect } from "primereact/multiselect";
import {
	listKnowledges,
	listObjectType,
} from "../../../../services/filters.service";
import { FiltersProps } from "../../../../@types";

export function ListFilters(props: any) {
	const { t: translation } = useTranslation();
	const [query, setQuery] = useState("");
	const [localFilters, setLocalFilters] = useState<FiltersProps>({});

	const queryParams = new URLSearchParams(window.location.search);
	const search = queryParams.get("search");

	var filter: any = {};

	useEffect(() => {
		if (search) {
			setQuery(search || localFilters?.q || "");
		} else {
			setQuery(localFilters?.q || "");
		}
	}, []);

	useEffect(() => {
		const timeOutId = setTimeout(() => {
			handleOnChange(query, "q");
		}, 500);
		return () => clearTimeout(timeOutId);
	}, [query]);

	const handleButtonClear = useCallback(() => {
		setQuery("");
		setMediaType(undefined);
		setKnowledges(undefined);
		setModality(undefined);
		setStatus(undefined);
		setLocalFilters({});
		handleSearch({});
	}, []);

	const handleSearch = useCallback(
		(_filter: any) => {
			props.handleFilter(_filter || localFilters?.q);
		},
		[props]
	);

	const handleOnChange = (event: any, field: any) => {
		filter = localFilters;
		if (field == "q") {
			filter[field] = event;
		} else if (field == "knowledge") {
			filter[field] = event.value;
			setKnowledges(event.value);
		} else if (field == "categories") {
			filter[field] = event.value;
			setMediaType(event.value);
		} else if (field == "modalities") {
			filter[field] = event.value;
			setModality(event.value);
		} else if (field == "deadline") {
			filter[field] = event.value;
			setStatus(event.value);
		}

		setLocalFilters(filter);

		handleSearch(localFilters);
	};

	// Taxonomy Filter
	const [knowledgesItems, setKnowledgesItems] = useState(undefined);
	const [knowledges, setKnowledges] = useState(localFilters?.knowledge);
	useEffect(() => {
		listKnowledges().then((resp) => {
			setKnowledgesItems(resp);
		});
	}, []);

	// ObjectType Filter
	const [objectItems, setObjectItems] = useState(undefined);
	const [mediaType, setMediaType] = useState(localFilters?.categories);
	useEffect(() => {
		listObjectType().then((resp) => {
			setObjectItems(resp);
		});
	}, []);

	const [modality, setModality] = useState(undefined);
	const modalityItems = [
		{ label: "Graduação", value: 1 },
		{ label: "Pós-graduação", value: 2 },
		{ label: "Livre", value: 3 },
		{ label: "Técnico", value: 4 },
	];

	const [status, setStatus] = useState(undefined);
	const statusItems = [
		{ label: "Pronta-entrega", value: 1 },
		{ label: "20 dias", value: 2 },
	];

	const objectsItemsTemplate = (option: any) => {
		return (
			<div className="country-item">
				<div style={{ marginTop: "-23px" }}>
					<i
						className="material-icons"
						style={{
							width: "24px",
							whiteSpace: "break-spaces",
							verticalAlign: "-7px",
						}}
					>
						{option.category_icon}
					</i>{" "}
					{option.title}
				</div>
			</div>
		);
	};

	return (
		<>
			<Col
				xs={12}
				md={props.hasModalityFilter ? 2 : 4}
				lg={props.hasModalityFilter ? 2 : 4}
				xl={props.hasModalityFilter ? 3 : 5}
				className="px-sm-1"
			>
				<InputGroup className="mb-2 mt-sm-0 ">
					<FormControl
						className="input-text"
						placeholder={translation("filters.search")}
						aria-label={translation("filters.search")}
						aria-describedby="basic-addon1"
						value={query}
						onChange={(event: any) => setQuery(event.target.value)}
					/>
					<InputGroup.Text>
						<FaSearch color="#606060"></FaSearch>
					</InputGroup.Text>
				</InputGroup>
			</Col>

			{!props.isCourseFilter && (
				<>
					<Col
						xs={12}
						md={2}
						lg={2}
						className="px-sm-1 mb-2"
					>
						<MultiSelectFilter>
							<MultiSelect
								value={knowledges}
								optionLabel="description"
								optionValue="description"
								placeholder={translation("filters.knowledge")}
								className="multiselect-dropdown ds-select"
								options={knowledgesItems}
								onChange={(event: any) =>
									handleOnChange(event, "knowledge")
								}
								filter
							/>
						</MultiSelectFilter>
					</Col>

					<Col
						xs={12}
						md={2}
						lg={2}
						className="px-sm-1 mb-2"
					>
						<MultiSelectFilter>
							<MultiSelect
								optionLabel="title"
								optionValue="title"
								value={mediaType}
								placeholder={translation("filters.objectType")}
								className="multiselect-dropdown ds-select"
								itemTemplate={objectsItemsTemplate}
								options={objectItems}
								onChange={(event: any) =>
									handleOnChange(event, "categories")
								}
								filter
							/>
						</MultiSelectFilter>
					</Col>

					<Col
						xs={12}
						md={2}
						lg={2}
						className="px-sm-1 mb-2"
					>
						<MultiSelectFilter>
							<MultiSelect
								optionLabel="label"
								optionValue="value"
								value={status}
								placeholder={translation("filters.status")}
								className="multiselect-dropdown ds-select"
								options={statusItems}
								onChange={(event: any) =>
									handleOnChange(event, "deadline")
								}
								filter
							/>
						</MultiSelectFilter>
					</Col>
				</>
			)}

			{(props.hasModalityFilter === true ||
				(props.isCourseFilter && props.isCourseFilter === true)) && (
				<Col
					xs={12}
					md={2}
					className="px-sm-1 mb-2"
				>
					<MultiSelectFilter>
						<MultiSelect
							value={modality}
							maxSelectedLabels={1}
							selectedItemsLabel={
								"{0} " + translation("filters.selectedLabel")
							}
							placeholder={translation("filters.modality")}
							panelHeaderTemplate={() => {
								return <></>;
							}}
							className="multiselect-dropdown ds-select"
							options={modalityItems}
							onChange={(event: any) =>
								handleOnChange(event, "modalities")
							}
						/>
					</MultiSelectFilter>
				</Col>
			)}

			<Col
				md={2}
				lg={2}
				xl={1}
				className="px-sm-1"
			>
				<CardButton>
					<button
						name="addbutton"
						type="button"
						onClick={handleButtonClear}
					>
						{translation("filters.clear")}
					</button>
				</CardButton>
			</Col>
		</>
	);
}
